import { render, staticRenderFns } from "./impact-panel.vue?vue&type=template&id=26534a3e&scoped=true"
import script from "./impact-panel.vue?vue&type=script&lang=js"
export * from "./impact-panel.vue?vue&type=script&lang=js"
import style0 from "./impact-panel.vue?vue&type=style&index=0&id=26534a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26534a3e",
  null
  
)

export default component.exports